import React, { useRef } from 'react'
import { useField } from 'formik'
import { useAlert } from '@hooks/useAlert'

import type { ImageType } from '@interfaces/ImageType'
import type { UploadBadgeFieldProps } from './interface'

export function withUploadBadgeField(
  Component: React.FC<UploadBadgeFieldProps>
) {
  function WithUploadStickerField() {
    const { error: alertError } = useAlert()
    const [{ value }, { error, touched }, { setValue }] =
      useField<ImageType>('upload')
    const inputRef = useRef<HTMLInputElement>(null)

    function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
      const { files } = event.target

      if (files) {
        const img = new Image()
        const url = URL.createObjectURL(files[0])
        img.src = url
        img.onload = () => {
          // check image extension sould be only png
          const ext = files?.[0]?.name?.split('.')?.pop()
          if (ext !== 'png') {
            alertError('ไฟล์ที่อัพโหลดต้องเป็นไฟล์ PNG เท่านั้น')
            URL.revokeObjectURL(url)
            return
          }

          // check if image is 15:16
          if (img.width / img.height !== 15 / 16) {
            alertError('รูปภาพต้องมีขนาด 15:16 เท่านั้น')
            URL.revokeObjectURL(url)
            return
          }

          setValue({
            url,
            blob: files[0],
          })
          URL.revokeObjectURL(url)
        }
      }
    }

    function showUploadDialog() {
      const event = inputRef.current
      if (event) {
        event.click()
      }
    }

    const componentProps = {
      inputRef,
      src: value?.url,
      isError: !!error && touched,
      onChange: handleChange,
      showUploadDialog,
    }

    return <Component {...componentProps} />
  }

  return WithUploadStickerField
}
